import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse, IRootState} from "../../../../types";
import {
    deletedBaseline, deletedRestoreBaseline,
    setBaseline, setBaselineBlocks,
    setRestoreBaseline,
    updateBaseline
} from "../store/baselineSlice";
import {IBaselineCreate, IBaselinePayload} from "../types";
import {setEducationalDegree} from "@pages/EducationalStructure/EducationalDegree/store/educationDegreeSlice";
import {setLearningFormat} from "@pages/EducationalStructure/LearningFormat/store/learningFormatSlice";
import {setAcademicYear} from "@pages/EducationalSettings/AcademicYear/store/academicYearSlice";
import {IBaselineCloneState} from "@pages/LearningManagement/Baseline/components/BaselineTable/types";


const GetBaseline= createAsyncThunk(
    "get/baseline",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/reference-datas");

            dispatch(setBaseline(response.data));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const SetBaseline= createAsyncThunk(
    "create/baseline",
    async ( data:IBaselineCreate ,{rejectWithValue}) => {
        try {
            const response = await request.post("/reference-datas", data);
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditBaseline= createAsyncThunk(
    "edit/baseline",
    async ( data :IBaselinePayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/reference-datas/${data.id}`, data);
            dispatch(updateBaseline(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteBaseline= createAsyncThunk(
    "delete/baseline",
    async (id:number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/reference-datas/${id}`);
            dispatch(deletedBaseline(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteBaseline= createAsyncThunk(
    "get/delete/baseline",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/reference-datas/deleted-items`);
            dispatch(setRestoreBaseline(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const RestoreDeleteBaseline = createAsyncThunk(
    "restore/delete/baseline",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/reference-datas/restore/${id}`);
            dispatch(deletedRestoreBaseline(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const BaselineCombinedData = createAsyncThunk(
    "baseline/combined",
    async (_,{ dispatch,rejectWithValue,getState }) => {
        try {
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            const response = await request.get("reference-datas/combinedData");
            dispatch(setEducationalDegree({ data: response.data.educational_degrees,defaultLanguage }));
            dispatch(setLearningFormat({data:response.data.learning_formats,defaultLanguage}));
            dispatch(setAcademicYear({data:response.data.academic_years,defaultLanguage}));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const GetBaselineBlocks =createAsyncThunk(
    "Get/baseline/blocks",
    async (id:number,{ dispatch,rejectWithValue })=>{
        try {
            const response = await request.get(`/reference-blocks/get-table/${id}`);

            dispatch(setBaselineBlocks(response.data))
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const EditBaselineBlocks = createAsyncThunk(
    "edit/baseline/blocks",
    async (data:any,{rejectWithValue})=>{

        try {
            const response = await request.put(`/reference-blocks/${data.id}`,data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const DeleteBaselineBlockRow =createAsyncThunk(
    "delete/baseline/block",
    async (id:number,{rejectWithValue})=>{

        try {
            const response = await request.delete(`/reference-blocks/${id}`);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }

)

const UpdateBaselineProfessions =createAsyncThunk(
    "update/baseline/professions",
    async (id:number,{rejectWithValue})=>{

        try {
            const response = await request.post(`/reference-datas/refresh/${id}`);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)


const CloneBaseline=createAsyncThunk(
    "clone/baseline",
    async (data:IBaselineCloneState,{rejectWithValue})=>{

        try {
            const response = await request.post(`/reference-datas/clone/${data.id}`,data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
)

export{
    GetBaseline,
    SetBaseline,
    EditBaseline,
    DeleteBaseline,
    GetDeleteBaseline,
    RestoreDeleteBaseline,
    BaselineCombinedData,
    GetBaselineBlocks,
    EditBaselineBlocks,
    DeleteBaselineBlockRow,
    UpdateBaselineProfessions,
    CloneBaseline
}